import { render } from "./PlaceholderPage.vue?vue&type=template&id=70a50713&scoped=true"
import script from "./PlaceholderPage.vue?vue&type=script&lang=js"
export * from "./PlaceholderPage.vue?vue&type=script&lang=js"

import "./PlaceholderPage.vue?vue&type=style&index=0&id=70a50713&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a50713"]])

export default __exports__